export default "__VITE_ASSET__DtZMkBQO__"